export default "__VITE_ASSET__CJvR2rPi__"